export function countTrailingConditionalAnswers(answerLogString) {
  const [, previousAnswers, currentAnswers = ''] = answerLogString.split('.');

  if (!previousAnswers || !answerLogString.endsWith('0')) {
    return 0;
  }

  let trailingAnswers = 0;
  let answerIndex = currentAnswers.length - 1;

  while (answerIndex >= 0 && currentAnswers[answerIndex] === '0') {
    trailingAnswers += 1;
    answerIndex -= 1;
  }

  return trailingAnswers;
}

export function getPreviousQuestionTransition({
  number,
  questionsAmount,
  answerLogString,
  progress,
  progressAmount,
  showReassurance,
}) {
  const midpointQuestion = Math.floor(questionsAmount / 2);
  const previousQuestion = number - 1;
  const trailingConditionalAnswers = countTrailingConditionalAnswers(answerLogString);

  if (trailingConditionalAnswers > 0) {
    const nextQuestion = previousQuestion - trailingConditionalAnswers;

    return {
      type: 'question',
      nextQuestion,
      nextProgress: progress - progressAmount * trailingConditionalAnswers,
      nextAnswerLogString: answerLogString.slice(0, -(trailingConditionalAnswers + 1)),
      toggleReassuranceBeforeUpdate: false,
      toggleReassuranceAfterUpdate: number > midpointQuestion && nextQuestion < midpointQuestion,
    };
  }

  if (previousQuestion === midpointQuestion - 1) {
    return {
      type: 'question',
      nextQuestion: previousQuestion,
      nextProgress: progress - progressAmount,
      nextAnswerLogString: answerLogString.slice(0, -1),
      toggleReassuranceBeforeUpdate: false,
      toggleReassuranceAfterUpdate: true,
    };
  }

  if (previousQuestion === -1) {
    return { type: 'navigateBack' };
  }

  return {
    type: 'question',
    nextQuestion: showReassurance ? number : previousQuestion,
    nextProgress: progress - progressAmount,
    nextAnswerLogString: answerLogString.slice(0, -1),
    toggleReassuranceBeforeUpdate: showReassurance,
    toggleReassuranceAfterUpdate: false,
  };
}
